
export class Area {
    dbId: number | undefined;
    text: string | undefined;    
}

export class Cell {
    id: number | undefined;
    name: string | undefined;    
}

export class Event extends Cell {    
}

export class Row {
    id: number | undefined;
    areaDbId: number | undefined;
    areaName: string | undefined;
    cellDbId: number | undefined;
    cellName: string | undefined;
    eventDbId: number | undefined;
    eventName: string | undefined;
}

